// extracted by mini-css-extract-plugin
export default {"sticky":"QPSHcPjYIcJ6IYpQu6tM","dateSwitcher":"Yg80wlQPdF4tAtAsGnwm","placeHolderShimmer":"X4zi6HpROPdOxSoesl39"};